import script from "./type.vue?vue&type=script&setup=true&lang=js"
export * from "./type.vue?vue&type=script&setup=true&lang=js"

import "./type.vue?vue&type=style&index=0&id=184220e2&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\payment-system-admin-yuyooke\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184220e2"]])

export default __exports__